import z from "zod";

export const diagnosticEntryObjectiveAttributesSchema = z.object({
  id: z.string().nullable(),
  does_not_need_estimate: z.boolean().nullable(),
}).partial();

export const updateDiagnosticEntrySchema = z.object({
  technical_response: z.string().optional(),
  deadline_to_complete_in_days: z.string().nullable(),
  objectives_attributes: z.array(diagnosticEntryObjectiveAttributesSchema).nullable(),
}).partial();

export type UpdateDiagnosticEntryValidationSchema = z.infer<typeof updateDiagnosticEntrySchema>;
